import { render, staticRenderFns } from "./vip-button-ladder.vue?vue&type=template&id=72aa7b72&scoped=true&lang=pug&"
import script from "./vip-button-ladder.vue?vue&type=script&lang=js&"
export * from "./vip-button-ladder.vue?vue&type=script&lang=js&"
import style0 from "./vip-button-ladder.vue?vue&type=style&index=0&id=72aa7b72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa7b72",
  null
  
)

export default component.exports